import i18n from "i18n";
export const visT = (key, options = {}) => i18n.t(key, { ns: "aggregation", ...options });
export const translatedOptions = (values, keyPrefix) => values.map((value) => [visT(`${keyPrefix}.${value}`), value]);
